import React from 'react';
import cx from 'classnames';
import { ChevronButton } from '@zola/zola-ui';
import styles from './styles.module.less';

const PageDots = ({ cardSuiteUUIDList, activePreview, className = '' }) => {
  return (
    <div className={cx(className, styles.pageDots)}>
      {cardSuiteUUIDList.map(uuid => (
        <div
          key={uuid}
          className={cx(styles.pageDot, { [styles.active]: uuid === activePreview })}
        />
      ))}
    </div>
  );
};

const PageButton = ({ disabled, next, last, onClick, className = '' }) => {
  const doNothing = () => {};

  if (last) {
    return (
      <div
        className={cx(className, styles.pageButton, styles.pageButtonLast, {
          [styles.disabled]: disabled,
        })}
      >
        <ChevronButton
          direction="left"
          btnStyle="tertiary"
          onClick={disabled ? doNothing : onClick}
        />
      </div>
    );
  }

  if (next) {
    return (
      <div
        className={cx(className, styles.pageButton, styles.pageButtonNext, {
          [styles.disabled]: disabled,
        })}
      >
        <ChevronButton
          direction="right"
          btnStyle="tertiary"
          onClick={disabled ? doNothing : onClick}
        />
      </div>
    );
  }

  return null;
};

export default { PageDots, PageButton };



// WEBPACK FOOTER //
// ./src/cards/components/common/SingleSample/SamplePreview/PreviewPages.jsx